if (!customElements.get('cart-cross-sell')) {
  class CartCrossSell extends HTMLElement {
    constructor() {
      super();
      this.handleAddToCart = this.handleAddToCart.bind(this);
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('button.cart-cross-sell__product-button');
      this.buttons.forEach(button => {
        if (!button.disabled) {
          button.addEventListener('click', this.handleAddToCart);
        }
      });
    }

    disconnectedCallback() {
      this.buttons?.forEach(button => {
        button.removeEventListener('click', this.handleAddToCart);
      });
    }

    async handleAddToCart(event) {
      const button = event.currentTarget;
      const variantId = button.dataset.variantId;

      if (!variantId || button.disabled || button.classList.contains('loading')) {
        return;
      }

      button.classList.add('loading');
      button.disabled = true;

      theme.cart.errors.clearFooter();

      try {
        await theme.cart.add({ id: variantId, quantity: 1 });
      } catch (_) {
      } finally {
        button.classList.remove('loading');
        button.disabled = false;
      }
    }
  }

  customElements.define('cart-cross-sell', CartCrossSell);
}
